function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, toRefs, watch, reactive, computed } from "vue";
import { definePropType } from "@types-vue/props";
import { Operation } from "../label/label-config";
import { fromGroupSchema, fromGroupModel } from "../label/label.dialog";
import { delTagGroup, saveTagGroup } from "@/api/material_label";
import { Message } from "element-ui";
import _ from "lodash";
import store from "@/store";
export default defineComponent({
    name: "table-group-dialog",
    props: {
        visible: {
            type: definePropType(Boolean),
            default: false,
            required: true
        },
        tableGroupItemInfo: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit, attrs = param.attrs;
        var resetForm = function resetForm() {
            var _$ref, _$ref1;
            if (!fromRef) return;
            (_$ref = fromRef.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
            (_$ref1 = fromRef.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.clearValidate();
        };
        var isConfirm = ref(false);
        var isShowEdit = ref(false);
        var saveLoading = ref(false);
        var dialogTitle = ref("");
        var fromRef = ref();
        var fromModelData = reactive({
            fromGroupModel: fromGroupModel
        });
        var fromSchemaData = reactive({
            fromGroupSchema: {}
        });
        var cascaderValue = computed(function() {
            return store.state.resource.cascaderValue;
        });
        var formConfig = computed(function() {
            return {
                inline: false,
                labelPosition: "right",
                labelWidth: "152px"
            };
        });
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var dialogAttrs = computed(function() {
            return _objectSpread({
                title: isConfirm.value ? "" : dialogTitle.value,
                width: isConfirm.value ? "450px" : "980px",
                center: isConfirm.value === true
            }, attrs);
        });
        watch(function() {
            return props.tableGroupItemInfo;
        }, function(val) {
            isConfirm.value = false;
            isShowEdit.value = false;
            if (val.operation === Operation.DELETE) {
                isConfirm.value = true;
            }
            if (val.operation === Operation.ADDLABEL) {
                dialogTitle.value = "\u65B0\u589E\u6807\u7B7E\u7EC4";
            }
            if (val.operation === Operation.REVISE) {
                dialogTitle.value = "\u4FEE\u6539\u6807\u7B7E\u7EC4";
                isShowEdit.value = true;
            }
        });
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                fromModelData.fromGroupModel.pid = "";
                var tableInfo = props.tableGroupItemInfo;
                fromSchemaData.fromGroupSchema = fromGroupSchema(isShowEdit.value && tableInfo.level === 1 ? 0 : Number(tableInfo.level), Number(tableInfo.is_leaf), String(tableInfo.operation));
                if (tableInfo.operation === "addLabel") {
                    fromModelData.fromGroupModel = _.cloneDeep(fromGroupModel);
                    fromModelData.fromGroupModel.level = tableInfo.level;
                    fromModelData.fromGroupModel.pid = tableInfo.pid;
                    resetForm();
                } else if (tableInfo.operation === "revise") {
                    fromModelData.fromGroupModel = _.assign(_.pick(tableInfo, [
                        "id",
                        "pid",
                        "level",
                        "name",
                        "category",
                        "asset_type",
                        "name_en",
                        "is_leaf",
                        "public",
                        "required",
                        "choice", 
                    ]), {
                        visible: 1
                    });
                }
            } else {
                cascaderValue.value.id = "";
                cascaderValue.value.level = 0;
            }
        });
        var successForm = function(type) {
            Message.success(type === "del" ? "\u5220\u9664\u6210\u529F" : "\u64CD\u4F5C\u6210\u529F");
            saveLoading.value = false;
            emit("update:visible", false);
            emit("refreshGroupList");
        };
        var handleChange = function(obj) {
            if (obj.prop === "is_leaf") {
                fromModelData.fromGroupModel.public = obj.value;
                fromModelData.fromGroupModel.required = obj.value;
                fromModelData.fromGroupModel.choice = obj.value;
                fromSchemaData.fromGroupSchema = fromGroupSchema(isShowEdit.value && props.tableGroupItemInfo.level === 1 ? 0 : Number(props.tableGroupItemInfo.level), Number(obj.value), String(props.tableGroupItemInfo.operation));
            }
        };
        var handleSaveLabelGroup = function() {
            var _ref1 = _asyncToGenerator(regeneratorRuntime.mark(function _callee1() {
                var _$ref;
                return regeneratorRuntime.wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            saveLoading.value = true;
                            if (!isConfirm.value) {
                                _ctx1.next = 13;
                                break;
                            }
                            _ctx1.prev = 2;
                            _ctx1.next = 5;
                            return delTagGroup({
                                id: String(props.tableGroupItemInfo.id)
                            });
                        case 5:
                            successForm("del");
                            _ctx1.next = 11;
                            break;
                        case 8:
                            _ctx1.prev = 8;
                            _ctx1.t0 = _ctx1["catch"](2);
                            saveLoading.value = false;
                        case 11:
                            _ctx1.next = 17;
                            break;
                        case 13:
                            ;
                            if (fromRef) {
                                _ctx1.next = 16;
                                break;
                            }
                            return _ctx1.abrupt("return");
                        case 16:
                            (_$ref = fromRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function() {
                                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(valid) {
                                    var levels, params;
                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (!valid) {
                                                    _ctx.next = 15;
                                                    break;
                                                }
                                                levels = 0;
                                                if (props.tableGroupItemInfo.pid === "0" || props.tableGroupItemInfo.pid === "") {
                                                    levels = 1;
                                                } else {
                                                    levels = cascaderValue.value.change || props.tableGroupItemInfo.operation === "addLabel" ? cascaderValue.value.level + 1 : cascaderValue.value.level;
                                                }
                                                params = _objectSpreadProps(_objectSpread({}, fromModelData.fromGroupModel), {
                                                    pid: props.tableGroupItemInfo.level === 0 ? "" : cascaderValue.value.id,
                                                    level: levels,
                                                    public: fromModelData.fromGroupModel.is_leaf === 2 ? 0 : fromModelData.fromGroupModel.public,
                                                    required: fromModelData.fromGroupModel.is_leaf === 2 ? 0 : fromModelData.fromGroupModel.required,
                                                    choice: fromModelData.fromGroupModel.is_leaf === 2 ? 0 : fromModelData.fromGroupModel.choice,
                                                    visible: Number(fromModelData.fromGroupModel.visible)
                                                });
                                                _ctx.prev = 4;
                                                _ctx.next = 7;
                                                return saveTagGroup(params);
                                            case 7:
                                                successForm();
                                                _ctx.next = 13;
                                                break;
                                            case 10:
                                                _ctx.prev = 10;
                                                _ctx.t0 = _ctx["catch"](4);
                                                saveLoading.value = false;
                                            case 13:
                                                _ctx.next = 16;
                                                break;
                                            case 15:
                                                {
                                                    saveLoading.value = false;
                                                }
                                            case 16:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            4,
                                            10
                                        ]
                                    ]);
                                }));
                                return function(valid) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        case 17:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1, null, [
                    [
                        2,
                        8
                    ]
                ]);
            }));
            return function handleSaveLabelGroup() {
                return _ref1.apply(this, arguments);
            };
        }();
        return _objectSpreadProps(_objectSpread({}, toRefs(fromSchemaData), toRefs(fromModelData)), {
            fromRef: fromRef,
            saveLoading: saveLoading,
            isConfirm: isConfirm,
            formConfig: formConfig,
            dialogTitle: dialogTitle,
            dialogVisible: dialogVisible,
            dialogAttrs: dialogAttrs,
            handleChange: handleChange,
            handleSaveLabelGroup: handleSaveLabelGroup
        });
    }
});
